module.exports = __webpack_public_path__ + "static/media/awad1.e46819de.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/awad1.png
// module id = 1662
// module chunks = 0